export const ActionTypes = {
  SET_ROLE_ALERT: 'SET_ROLE_ALERT',
  CLEAR_ROLE_ALERT: 'CLEAR_ROLE_ALERT',
  SET_DICTIONARY_ALERT: 'SET_DICTIONARY_ALERT',
  CLEAR_DICTIONARY_ALERT: 'CLEAR_DICTIONARY_ALERT',
  SET_USER_ALERT: 'SET_USER_ALERT',
  CLEAR_USER_ALERT: 'CLEAR_USER_ALERT',
  SET_AUTH_ALERT: 'SET_AUTH_ALERT',
  CLEAR_AUTH_ALERT: 'CLEAR_AUTH_ALERT',
  SET_LEGAL_ENTITY_ALERT: 'SET_LEGAL_ENTITY_ALERT',
  CLEAR_LEGAL_ENTITY_ALERT: 'CLEAR_LEGAL_ENTITY_ALERT',
  SET_LEGAL_ENTITY_ORG_ALERT: 'SET_LEGAL_ENTITY_ORG_ALERT',
  CLEAR_LEGAL_ENTITY_ORG_ALERT: 'CLEAR_LEGAL_ENTITY_ORG_ALERT',
  SET_LEGAL_ENTITY_ACTIVATE_ALERT: 'SET_LEGAL_ENTITY_ACTIVATE_ALERT',
  CLEAR_LEGAL_ENTITY_ACTIVATE_ALERT: 'CLEAR_LEGAL_ENTITY_ACTIVATE_ALERT',
  SET_LEGAL_ENTITY_DEACTIVATION_WARNINGS_ALERT: 'SET_LEGAL_ENTITY_DEACTIVATION_WARNINGS_ALERT',
  CLEAR_LEGAL_ENTITY_DEACTIVATION_WARNINGS_ALERT:
    'CLEAR_LEGAL_ENTITY_DEACTIVATION_WARNINGS_ALERT',
  SET_SAME_PAGE_ALERT: 'SET_SAME_PAGE_ALERT',
  CLEAR_SAME_PAGE_ALERT: 'CLEAR_SAME_PAGE_ALERT',
  SET_API_ALERT: 'SET_API_ALERT',
  CLEAR_API_ALERT: 'CLEAR_API_ALERT',
  SET_NEXT_PAGE_ALERT: 'SET_NEXT_PAGE_ALERT',
  CLEAR_NEXT_PAGE_ALERT: 'CLEAR_NEXT_PAGE_ALERT',
  SET_TRANSACTION_ALERT: 'SET_TRANSACTION_ALERT',
  CLEAR_TRANSACTION_ALERT: 'CLEAR_TRANSACTION_ALERT',
  SET_ANCILLARY_ALERT: 'SET_ANCILLARY_ALERT',
  CLEAR_ANCILLARY_ALERT: 'CLEAR_ANCILLARY_ALERT',
  SET_TRUSTED_DEVICE_ALERT: 'SET_TRUSTED_DEVICE_ALERT',
  CLEAR_TRUSTED_DEVICE_ALERT: 'CLEAR_TRUSTED_DEVICE',
  SET_FIREARM_ALERT: 'SET_FIREARM_ALERT',
  CLEAR_FIREARM_ALERT: 'CLEAR_FIREARM_ALERT',
  SET_ACCESSORY_ALERT: 'SET_ACCESSORY_ALERT',
  CLEAR_ACCESSORY_ALERT: 'CLEAR_ACCESSORY_ALERT',
  SET_AMMUNITION_ALERT: 'SET_AMMUNITION_ALERT',
  CLEAR_AMMUNITION_ALERT: 'CLEAR_AMMUNITION_ALERT',
  SET_COMPONENT_ALERT: 'SET_COMPONENT_ALERT',
  CLEAR_COMPONENT_ALERT: 'CLEAR_COMPONENT_ALERT',
  SET_AUDIT_LOG_SAME_PAGE_ALERT: 'SET_AUDIT_LOG_SAME_PAGE_ALERT',
  CLEAR_AUDIT_LOG_SAME_PAGE_ALERT: 'CLEAR_AUDIT_LOG_SAME_PAGE_ALERT',
  SET_ADDRESS_DELETION_ALERT: 'SET_ADDRESS_DELETION_ALERT',
  CLEAR_ADDRESS_DELETION_ALERT: 'CLEAR_ADDRESS_DELETION_ALERT',
  SET_ATTACHMENT_ALERT: 'SET_ATTACHMENT_ALERT',
  CLEAR_ATTACHMENT_ALERT: 'CLEAR_ATTACHMENT_ALERT',
  SET_DOCUMENTS_ALERT: 'SET_DOCUMENTS_ALERT',
  CLEAR_DOCUMENTS_ALERT: 'CLEAR_DOCUMENTS_ALERT',
  SET_FRT_ALERT: 'SET_FRT_ALERT',
  CLEAR_FRT_ALERT: 'CLEAR_FRT_ALERT',
  SET_TASK_ALERT: 'SET_TASK_ALERT',
  SET_INTELLIGENCE_REPORT_ALERT: 'SET_INTELLIGENCE_REPORT_ALERT',
  CLEAR_INTELLIGENCE_REPORT_ALERT: 'SET_INTELLIGENCE_REPORT_ALERT',
  CLEAR_TASK_ALERT: 'CLEAR_TASK_ALERT',
  SET_DOCUMENT_ALERT: 'SET_DOCUMENT_ALERT',
  CLEAR_DOCUMENT_ALERT: 'CLEAR_DOCUMENT_ALERT',
  SET_APPLICATION_PROCESS_ALERT: 'SET_APPLICATION_PROCESS_ALERT',
  CLEAR_APPLICATION_PROCESS_ALERT: 'CLEAR_APPLICATION_PROCESS_ALERT',
  SET_MODAL_ALERT: 'SET_MODAL_ALERT',
  CLEAR_MODAL_ALERT: 'CLEAR_MODAL_ALERT',
  SET_PRINTOUT_ERROR_LOG_ALERT: 'SET_PRINTOUT_ERROR_LOG_ALERT',
  CLEAR_PRINTOUT_ERROR_LOG_ALERT: 'CLEAR_PRINTOUT_ERROR_LOG_ALERT',
};
